import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import numeral from "numeral";
import EstimatePrice from "./EstimatePrice";
import ActivationPrice from "./ActivationPrice";

const style = {
  boxLabel: {
    display: "inline-block",
    marginTop: 26,
    marginLeft: 59
  },
  label: {
    height: 24,
    width: 100,
    color: "#3E3E40",
    fontFamily: "Fira Sans",
    fontSize: 16
  },
  trDevice: {
    display: "flex",
    marginBottom: 43
  },
  trStorage: {
    display: "flex"
  },
  textPriceDevice: {
    color: "#3E3E40",
    fontFamily: "Fira Sans",
    fontSize: 13,
    marginLeft: 65,
    marginTop: 2
  },
  textPrice: {
    extend: "textPriceDevice",
    fontSize: 16,
    fontWeight: 600,
    textAlign: "right",
    marginLeft: 185,
    width: 110
  },
  labelPrice: {
    color: "#A7A8A8",
    fontFamily: "Fira Sans",
    fontSize: 14,
    fontWeight: 400,
    display: "block"
  },
  boxValue: {
    height: 164,
    backgroundColor: "#FCFCFC"
  },
  boxResult: {
    extend: "box",
    height: 243,
    width: 765,
    borderTop: "3px solid #0E283D",
    border: "1px solid #F2F2F2",
    backgroundColor: "#FFFFFF",
    marginBottom: 5
  }
};

const MonthlyPrice = ({
  classes,
  storagePrice,
  devicePrice,
  perdevicePrice,
  perdeviceActivation,
  activationPrice
}) => {
  const device = numeral(devicePrice).format("$0,0.00");
  const storage = numeral(storagePrice).format("$0,0.00");
  const perDevice = numeral(perdevicePrice).format("$0,0.0000");
  let monthly = devicePrice + storagePrice;
  const props = { activationPrice, perdeviceActivation };

  return (
    <div>
      <div className={classes.boxResult}>
        <div className={classes.boxValue}>
          <table className={classes.boxLabel}>
            <tbody>
              <tr className={classes.trDevice}>
                <td className={classes.label}>Device fee</td>
                <td className={classes.textPrice}>
                  {device}
                  <span className={classes.labelPrice}>monthly</span>
                </td>
                <td className={classes.textPriceDevice}>
                  {perDevice}
                  <span className={classes.labelPrice}>per device</span>
                </td>
              </tr>
              <tr className={classes.trStorage}>
                <td className={classes.label}>Storage fee</td>
                <td className={classes.textPrice}>
                  {storage}
                  <span className={classes.labelPrice}>monthly</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <EstimatePrice monthly={monthly} />
      </div>
      <ActivationPrice {...props} />
    </div>
  );
};

MonthlyPrice.propTypes = {
  classes: PropTypes.object.isRequired,
  devicePrice: PropTypes.number.isRequired,
  storagePrice: PropTypes.number.isRequired,
  perdevicePrice: PropTypes.number.isRequired,
  activationPrice: PropTypes.number.isRequired,
  perdeviceActivation: PropTypes.number.isRequired
};

export default injectSheet(style)(MonthlyPrice);
